/*
Copyright (c) 2021 by Anders Grimsrud (https://codepen.io/agrimsrud/pen/XWNLMeW)
Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

// const navItems = navListItems.map(listItem => {
//         const anchor = listItem.querySelector('a'),
//             targetID = anchor && anchor.getAttribute('href').slice(1),
//             target = document.getElementById(targetID);
//         return { listItem, anchor, target };
//     })
//         .filter(item => item.target);

const visibleClass = "js-t";
let elementsToObserve, nav, navPath, observer;
let navItems = [];

// === Functions ===
function drawPath() {
  let path = [],
    pathIndent;
  navItems.forEach((item, i) => {
    const x = item.anchor.offsetLeft - 5,
      y = item.anchor.offsetTop,
      height = item.anchor.offsetHeight;

    if (i === 0) {
      path.push("M", x, y, "L", x, y + height);
      item.pathStart = 0;
    } else {
      if (pathIndent !== x) path.push("L", pathIndent, y);

      path.push("L", x, y);

      navPath.setAttribute("d", path.join(" "));
      item.pathStart = navPath.getTotalLength() || 0;
      path.push("L", x, y + height);
    }

    pathIndent = x;
    navPath.setAttribute("d", path.join(" "));
    item.pathEnd = navPath.getTotalLength();
  });
}

function syncPath() {
  const someElsAreVisible = () =>
      nav.querySelectorAll(`.${visibleClass}`).length > 0,
    thisElIsVisible = (el) => el.classList.contains(visibleClass),
    pathLength = navPath.getTotalLength();

  let pathStart = pathLength,
    pathEnd = 0,
    lastPathStart,
    lastPathEnd;

  navItems.forEach((item) => {
    if (thisElIsVisible(item.listItem)) {
      pathStart = Math.min(item.pathStart, pathStart);
      pathEnd = Math.max(item.pathEnd, pathEnd);
    }
  });

  if (someElsAreVisible() && pathStart < pathEnd) {
    if (pathStart !== lastPathStart || pathEnd !== lastPathEnd) {
      const dashArray = `1 ${pathStart} ${pathEnd - pathStart} ${pathLength}`;

      navPath.style.setProperty("stroke-dashoffset", "1");
      navPath.style.setProperty("stroke-dasharray", dashArray);
      navPath.style.setProperty("opacity", 1);
    }
  } else {
    navPath.style.setProperty("opacity", 0);
  }
  lastPathStart = pathStart;
  lastPathEnd = pathEnd;
}

function markVisibleSection(observedEls) {
  observedEls.forEach((observedEl) => {
    const id = observedEl.target.getAttribute("id"),
      anchor = document.querySelector(`nav li a[href="#${id}"]`);
    if (!anchor) return false;
    const listItem = anchor.parentElement;
    if (observedEl.isIntersecting) {
      listItem.classList.add(visibleClass);
    } else {
      listItem.classList.remove(visibleClass);
    }
    syncPath();
  });
}

// === Draw path and observe ===
function cheese(n) {
  const targetID = n.getAttribute("id");
  const anchor = document.querySelector(`nav li a[href="#${targetID}"]`);
  const listItem = anchor.parentElement;
  const target = document.getElementById(targetID);
  navItems.push({ listItem, anchor, target });
}

export function initProgressNav() {
  elementsToObserve = document.querySelectorAll("h2[id],h3[id],h4[id],h5[id]");
  nav = document.getElementById("js-toc-nav");
  navPath = document.getElementById("js-toc-path");
  elementsToObserve.forEach(cheese);
  navItems = navItems.filter((item) => item.target);

  drawPath();
  observer = new IntersectionObserver(markVisibleSection);
  elementsToObserve.forEach((thisEl) => observer.observe(thisEl));
}
